import React from 'react'
import { Management } from 'components/NotProductIcons'
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image'
import { prepareData } from 'utils/googleData'

interface ExecutiveProps {
    SvgLogo?: string
    logo?: string
    width?: number
    height?: number
    photo?: string
    large?: string
    name: string
    role?: string
}

const Executive = ({ SvgLogo, logo, width, height, photo, large, name, role }: ExecutiveProps) => {
    return (
        <div className="flex flex-col items-center justify-center border-t border-l border-dashed border-gray-accent-light text-center">
            {SvgLogo ? (
                <div className="py-8 px-4">
                    <figure className="mb-0 text-center">
                        <img src={SvgLogo} width={width} height={height} alt={name} />
                    </figure>
                </div>
            ) : logo ? (
                <div className="py-8 px-4">
                    <figure className="mb-0 text-center">
                        <img src={logo} width={width} height={height} alt={name} />
                    </figure>
                </div>
            ) : photo ? (
                <div className="flex flex-col justify-center py-4 px-4">
                    <figure className="mx-auto mb-2 rounded-full border border-solid border-gray bg-white p-[2px]">
                        {large ? (
                            <img src={photo} width={80} height={80} alt={name} className="rounded-full " />
                        ) : (
                            <img src={photo} width={50} height={50} alt={name} className="rounded-full " />
                        )}
                    </figure>
                    <h5 className="mb-0">{name}</h5>
                    <p className="mb-0 text-sm opacity-60">{role}</p>
                </div>
            ) : (
                <div className="px-12 py-8">
                    <h5 className="mb-0 font-semibold uppercase leading-tight">{name}</h5>
                </div>
            )}
        </div>
    )
}

const AboutManagementCtaSubSection = ({ cta }) => {
    return (
        <div className="flex flex-col justify-center border-t border-l border-dashed border-gray-accent-light py-4 px-4">
            <figure className="mx-auto mb-2 flex h-[50px] w-[50px] items-center justify-center rounded-full border border-solid border-gray bg-gray-accent-light p-[2px]">
                <span className="inline-block h-8 w-8">
                    <Management />
                </span>
            </figure>
            <p className="mb-0 text-center text-sm font-medium opacity-60">
                ( {cta.name}
                <a href={cta.url}>{cta.title}</a>
                !)
            </p>
        </div>
    )
}

export const AboutManagement = (props) => {
    const {
        enable,
        story,
        subtitle,
        description,
        cta,
        cta2,
        svgImage,
        gatsbyImage,
        gatsbyImageSrc,
        aboutManagementTitle,
        id,
        style,
        executives,
    } = prepareData({
        props,
    })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    const googleImages = props?.data?.pageData?.nodes?.[0].parent?.images
    return (
        <section id={id} className={`mt-16 mb-12 ${style}`}>
            <h3 className="mb-1 text-center text-5xl">{aboutManagementTitle?.title}</h3>
            <h4 className="mb-12 text-center font-semibold opacity-70">{aboutManagementTitle?.subTitle}</h4>

            <div className="grid grid-cols-2 border-b border-r border-dashed border-gray-accent-light lg:grid-cols-4">
                {executives?.length > 0 &&
                    executives?.map(({ name, photo, role }, index) => {
                        const googleImage =
                            photo &&
                            googleImages &&
                            googleImages.filter((img) => {
                                if (img.name == photo) {
                                    return img
                                }
                            })[0]
                        return (
                            <Executive
                                key={index}
                                photo={googleImage?.publicURL}
                                name={name}
                                role={role}
                                large
                                width={172}
                                height={59}
                            />
                        )
                    })}

                {cta?.name !== '' && <AboutManagementCtaSubSection cta={cta} />}
            </div>
        </section>
    )
}
